import {SET_CURRENT_RIDE_CATEGORIES} from "./action_ride_categories";

const INITIAL_STATE = {
    currentRideCategories: []
}

const rideCategoriesReducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case SET_CURRENT_RIDE_CATEGORIES:
            return {
                ...state,
                currentRideCategories: action.payload
            }
        default:
            return state;
    }
}

export default rideCategoriesReducer;
